export default __webpack_public_path__ + "static/media/linkedin.aa45f7b0.svg";